// extracted by mini-css-extract-plugin
module.exports = {"container":"Button_container__AkbTG","button":"Button_button__x6lHc","clicked":"Button_clicked__PYXKw","disabled":"Button_disabled__v9bDY","ghost":"Button_ghost__kj1h_"};